import { useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  let changeBoardId = useDataChange({
    context: 'form',
    path: 'board_id',
    viewPath: props.viewPath,
  })

  let changeStageId = useDataChange({
    context: 'form',
    path: 'stage_id',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    changeBoardId(value)
    changeStageId(null)
  }
}
